import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollableItem]',
  standalone: false
})
export class ScrollableItemDirective {
  constructor(private el: ElementRef<HTMLElement>) {}

  @Input('appScrollableItem')
  public key: string;

  public scrollIntoView() {
    this.el.nativeElement.scrollIntoView({ behavior: 'smooth', inline: 'start' });
  }
}
